import emailjs from '@emailjs/browser';

const EMAILJS_SERVICE_ID = 'koltora.app@gmail.com';
const EMAILJS_TEMPLATE_ID = 'template_fudcjpy';
const EMAILJS_PUBLIC_KEY = 'Sn2-WHbvk6MbCwovy';
const CONTACT_EMAIL = 'koltora.app@gmail.com';

export interface ContactMessage {
  name: string;
  email: string;
  message: string;
}

export async function sendContactMessage({ name, email, message }: ContactMessage): Promise<void> {
  await emailjs.send(
    EMAILJS_SERVICE_ID,
    EMAILJS_TEMPLATE_ID,
    {
      from_name: name,
      from_email: email,
      reply_to: email,
      // Embed sender details in the message body so they always reach
      // the inbox even if the EmailJS template doesn't render from_email.
      message: `${message}\n\n---\n${name}\n${email}`,
      to_email: CONTACT_EMAIL,
    },
    EMAILJS_PUBLIC_KEY,
  );
}
